// client/src/components/auth/profile/ContactInfoCard.js
import React, { useState, useEffect } from 'react'
import FloatingInput from './FloatingInput'
import addRipple from '../../../utils/ripple'
import '../../../styles/profileFields.css'

function ContactInfoCard({
  playerData,
  onPlayerDataChange,
  isEditing,
  onEditClick,
  editingField,
  onInlineSave,
  onInlineCancel,
}) {
  const [formData, setFormData] = useState({
    phone_number: playerData?.phone_number || '',
    address: playerData?.address || '',
  })

  // Sync form data with playerData only when transitioning out of edit mode
  // Store previous isEditing state to detect transitions
  const [wasEditing, setWasEditing] = useState(false)

  useEffect(() => {
    // Only sync when transitioning from editing to NOT editing (save/cancel completed)
    if (wasEditing && !isEditing) {
      if (playerData) {
        setFormData({
          phone_number: playerData.phone_number || '',
          address: playerData.address || '',
        })
      } else {
        setFormData({ phone_number: '', address: '' })
      }
    }
    setWasEditing(isEditing)
  }, [isEditing, playerData, wasEditing])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    const newLocalFormData = { ...formData, [name]: value }
    setFormData(newLocalFormData)
    onPlayerDataChange(newLocalFormData) // Update parent so it has latest data for save
  }

  const isFieldEditing = (field) => isEditing && editingField === field

  // Render field chip - don't define as component to avoid remounting
  const renderFieldChip = (field, label, value, editor) => {
    if (isFieldEditing(field)) {
      return (
        <div className="field-chip editing" data-field={field} key={field}>
          <span className="chip-label">{label}</span>
          <div className="chip-editor">
            {editor}
            <div className="chip-actions">
              <button
                type="button"
                className="icon-btn confirm"
                onClick={() => onInlineSave && onInlineSave(field)}
                aria-label="Save"
              >
                ✓
              </button>
              <button
                type="button"
                className="icon-btn cancel"
                onClick={() => onInlineCancel && onInlineCancel(field)}
                aria-label="Cancel"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )
    }
    return (
      <button
        type="button"
        className="field-chip"
        key={field}
        onClick={(e) => {
          addRipple(e)
          onEditClick(field)
        }}
      >
        <span className="chip-label">{label}</span>
        <span className="chip-value">{value || '—'}</span>
      </button>
    )
  }

  return (
    <div className="profile-card">
      <h5 className="section-title">📱 Contact Information</h5>
      <div className="chip-row">
        {renderFieldChip(
          'phone_number',
          'Phone',
          formData.phone_number,
          <FloatingInput
            label="Phone Number"
            name="phone_number"
            type="tel"
            inputMode="tel"
            value={formData.phone_number}
            onChange={handleInputChange}
            placeholder="(555) 123-4567"
            disabled={!isFieldEditing('phone_number')}
          />,
        )}
        {renderFieldChip(
          'address',
          'Address',
          formData.address,
          <FloatingInput
            label="Address"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            placeholder="123 Main St, City, State"
            disabled={!isFieldEditing('address')}
          />,
        )}
      </div>
    </div>
  )
}

export default ContactInfoCard
